import React from 'react';
import Chip from '@mui/material/Chip';

const Label = ({ color, name }) => {
  const statusColorMap = {
    invited: '#007bff',
    active: '#28a745',
    inactive: '#6c757d',
    pending: '#ffc107',
    suspended: '#dc3545',
    'invite-accepted': '#17a2b8',
    'delete-requested': '#dc3545',
  };

  const finalColor = color || statusColorMap[name] || '#1b3f87';

  return (
    <Chip
      label={name?.toUpperCase()}
      size="small"
      sx={{
        backgroundColor: finalColor,
        color: 'white',
        fontWeight: 500,
        fontSize: '12px',
        borderRadius: '5px',
        height: '24px',
        '& .MuiChip-label': {
          px: 1,
        },
      }}
    />
  );
};

export default Label;